"use client"
/* */
const lightBox = "flow--light-box";
const content = "flow--light-box--content";
const fitScreen = "flow--light-box--fit-screen";
const actions = "flow--light-box--actions";
const actionGroup = "flow--light-box--action-group";
const styles = {
	lightBox: lightBox,
	content: content,
	fitScreen: fitScreen,
	actions: actions,
	actionGroup: actionGroup
};

export { actionGroup, actions, content, styles as default, fitScreen, lightBox };
//# sourceMappingURL=LightBox.module.scss.mjs.map
